import { Bouncer } from "./Bouncer";
export async function loadExternalBounceInteraction(engine, refresh = true) {
    await engine.addInteractor("externalBounce", (container) => new Bouncer(container), refresh);
}
export * from "./Options/Classes/Bounce";
export * from "./Options/Interfaces/IBounce";
